import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "../Components/Layouts/AuthLayout";
import ErrorBoundary from "../AppComponents/AppErrorBoundary";
import LinearLoader from "../AppComponents/Loader/LinearLoader";

const LoginPage = lazy(() => import("../Components/Welcome/LoginPage"));
const NewPasswordPage = lazy(
  () => import("../Components/Welcome/NewPasswordPage")
);
const ResetPasswordPage = lazy(
  () => import("../Components/Welcome/ResetPasswordPage")
);
const SignupPage = lazy(() => import("../Components/Welcome/SignupPage"));
const UserVerificationPage = lazy(
  () => import("../Components/Welcome/UserVerify")
);
const VerifyMobilePage = lazy(
  () => import("../Components/Welcome/VerifyMobilePage")
);
const VerifyOTPPage = lazy(
  () => import("../Components/Welcome/VerifyOTPPage")
);
const BusniessVerificationPage = lazy(
  () => import("../Components/Welcome/BusniessVerificationPage")
);
const App404 = lazy(() => import("../AppComponents/App404"));

const AuthRoutes = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LinearLoader />}>
        <Routes>
          <Route path="/" element={<AuthLayout />}>
            <Route index element={<LoginPage />} />
            <Route path="/agent/verify" element={<UserVerificationPage />} />
            <Route
              path="/account/verify"
              element={<BusniessVerificationPage />}
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route
              path="/signup/email=:emailFromUrl"
              element={<SignupPage />}
            />
            <Route path="/verify-mobile" element={<VerifyMobilePage />} />
            <Route path="/verify-otp" element={<VerifyOTPPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/change-password/:useremail"
              element={<NewPasswordPage />}
            />
            <Route path="/404" element={<App404 />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};

export default AuthRoutes;
